import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const PowerCutIllustration = ({ width = 272 }: DefaultIconProps) => (
  <DefaultIconWrapper width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 272 214">
      <defs>
        <path id="91mp2qy55a" d="M0 0.488L137.912 0.488 137.912 64.563 0 64.563z" />
        <path id="v0jwfcberc" d="M0 214L272 214 272 0 0 0z" />
      </defs>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(0 76)">
          <path
            fill="#94C9E2"
            d="M136.007 26.33c1.051 0 1.905-.852 1.905-1.903v-9.44c0-1.05-.854-1.902-1.905-1.902h-20.795V2.815c0-1.285-1.043-2.327-2.328-2.327H83.956C69.59.488 57.43 9.925 53.348 22.932H0V42.12h53.348C57.43 55.126 69.59 64.563 83.956 64.563h28.928c1.285 0 2.328-1.04 2.328-2.325v-10.27h20.795c1.051 0 1.905-.852 1.905-1.903v-9.44c0-1.05-.854-1.902-1.905-1.902h-20.795V26.33h20.795z"
          />
        </g>
        <path
          fill="#94C9E2"
          d="M272 98.417h-52.936C214.984 85.427 202.827 76 188.464 76H164.328c-1.286 0-2.328 1.04-2.328 2.324v59.353c0 1.284 1.042 2.323 2.328 2.323h24.137c14.362 0 26.518-9.425 30.6-22.417H272V98.417z"
        />

        <path
          fill="#B2B2B2"
          d="M136 38L144 38 144 0 136 0zM176.516 51L171 45.485 191.485 25 197 30.515zM103.484 51L83 30.515 88.516 25 109 45.485zM136 214L144 214 144 176 136 176zM88.516 189L83 183.484 103.484 163 109 168.515zM191.485 189L171 168.515 176.516 163 197 183.484z"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M218.736 98.417C214.65 85.427 202.476 76 188.094 76H186c6.685 0 12.105 14.326 12.105 32.001 0 17.672-5.418 31.998-12.104 31.999h2.093c14.383 0 26.556-9.425 30.644-22.417l53.262-.25V98.166l-53.264.25zM136.078 101.812c1.06 0 1.922-.851 1.922-1.901v-9.429c0-1.05-.861-1.9-1.922-1.9h-20.977V78.325c0-1.284-1.051-2.325-2.348-2.325H87c6.735.002 12.195 14.328 12.195 32S93.735 140 87 140h25.753c1.297 0 2.348-1.039 2.348-2.323V127.42h20.977c1.06 0 1.922-.85 1.922-1.9v-9.429c0-1.05-.861-1.9-1.922-1.9h-20.977v-12.378h20.977z"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
